'use client';

import * as React from 'react';
import { Theme } from '@mui/material';
import { SxProps } from '@mui/system/styleFunctionSx';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { CmsHtmlContent } from '@/components/CmsHtmlContent';
import { CmsElementContent } from '@/services/cms/blocks/CmsElementContent';

export interface ElementContentBlockProps extends CmsElementContent {
    sx?: SxProps<Theme>;
}

export const ElementContentBlock = ({ sx, ...props }: ElementContentBlockProps) => (
    <BlockContainer sx={sx} {...props}>
        <BlockTitle {...props} />
        <CmsHtmlContent html={props.html} />
    </BlockContainer>
);
